import { Button, Typography } from '@mui/material';
import { Add } from '@mui/icons-material';

import Flex from '@Components/Bases/Flex';
import { useDisclosure } from '@hooks/useDisclosure';
import GoalModal from './GoalModal';
import GoalTable from '../GoalTable/GoalTable';
import { useWatch } from 'react-hook-form';
import { useGoalAndOperationalPlansForm } from '@Router/GoalAndOperationalPlans/Containers/GoalAndOperationalPlansFormProvider';

const Goals = ({ planIndex }: { planIndex: number }) => {
  const [formOpened, { open: openForm, close: closeForm }] = useDisclosure();

  const {
    formState: { errors },
  } = useGoalAndOperationalPlansForm();
  const completedSection = useWatch({
    name: 'completedSection',
  });

  const { isCompletedTh, isCompletedEn } = completedSection ?? {};
  const goalsError =
    errors.companyValueIncreasePlans?.valueUpPlans?.[planIndex]?.goals;

  return (
    <Flex flexDirection={'column'} my={5}>
      <Flex justifyContent={'space-between'} alignItems={'center'} mb={2}>
        <Typography fontWeight={'bold'}>เป้าหมายที่ {planIndex + 1}</Typography>
        <Button
          color={'inherit'}
          startIcon={<Add />}
          onClick={openForm}
          disabled={isCompletedTh || isCompletedEn}
        >
          เพิ่มเป้าหมาย
        </Button>
      </Flex>
      <GoalTable planIndex={planIndex} />
      {goalsError && (
        <Typography mt={1} variant={'caption'} color={'error.main'}>
          {goalsError.message}
        </Typography>
      )}
      {formOpened && (
        <GoalModal
          actionType="add"
          open={formOpened}
          onClose={closeForm}
          planIndex={planIndex}
        />
      )}
    </Flex>
  );
};

export default Goals;
